import * as React from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { Form } from "react-bootstrap";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";

export class MultiSelectCustomCard extends React.Component<any, any> {
    static defaultProps = {
        isSearch: true,
        isSelectAll : true
    };
    private ddlRef: any;
    private searchSection: any;
    private dropDownFooter: any;
    constructor(props) {
        super(props);

        this.state = {
            opened: false,
            inputValue: "",
            filterData: props.data || [],
        };

        this.ddlRef = React.createRef();
        this.searchSection = React.createRef();
        this.dropDownFooter = React.createRef();
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        // Update filter data when input changes or new data comes in
        if (
            prevProps.data !== this.props.data ||
            prevState.inputValue !== this.state.inputValue
        ) {
            const { inputValue } = this.state;
            const { data, labelKey } = this.props;

            const filtered = (data || []).filter((item) =>
                item[labelKey].toLowerCase().includes(inputValue.toLowerCase())
            );

            this.setState({ filterData: filtered });
        }
    }

    onChipMouseOver = (): void => {
        this.setState({ childClick: true });
    };

    handleClick = () => {
        this.setState((prev) => ({ opened: !prev.opened }),
            () =>
                this.dropDownFooter.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "end",
                    inline: "nearest",
                }));
    };

    handleOutsideClick = () => {
        this.setState({ opened: false });
    };

    handleKeyUp = (e) => {
        if (e.key === "Tab") {
            this.setState({ opened: false });
        }
    };

    onTabKeyDown = (e) => {
        e.preventDefault();
        if (!this.state.opened && e?.keyCode === 9) {
            this.handleClick();
        }
    };

    onChipMouseOut = (): void => {
        this.setState({ childClick: false });
    };

    handleSearchChange = (e) => {
        this.setState({ inputValue: e.target.value });
    };

    toggleValue = (val) => {
        const { selectedValues = [], onChange } = this.props;
        if (selectedValues.includes(val)) {
            onChange(selectedValues.filter((v) => v !== val));
        } else {
            onChange([...selectedValues, val]);
        }
    };

    handleSelectAll = () => {
        const { data, valueKey, onChange } = this.props;
        const all = (data || []).map((item) => item[valueKey]);
        onChange(all);
        this.setState({ opened: false }, () => this.dropDownFooter.current?.scrollIntoView());
    };

    handleClearAll = () => {
        const { onChange } = this.props;
        onChange([]);
    };

    handleRemoveValue = (val) => {
        const { selectedValues = [], onChange } = this.props;
        onChange(selectedValues.filter((v) => v !== val));
    };

    render() {
        const hoverOutEllipsis = () => {
            $(".tooltip").removeClass("show");
        };
        const {
            data = [],
            labelKey = "label",
            valueKey = "value",
            selectedValues = [],
            placeholder = "Select options"
        } = this.props;

        const { opened, inputValue, filterData } = this.state;

        return (
            <OutsideClickHandler onOutsideClick={this.handleOutsideClick}>
                <div
                    className={`multiSelectSearch ${opened ? "opened" : ""}`}
                // onKeyUp={this.handleKeyUp}
                >
                    <div
                        onKeyUp={(e) => this.onTabKeyDown(e)}
                        tabIndex={0}
                        className="fieldArea"
                        onClick={this.handleClick}
                        ref={this.ddlRef}
                        onMouseOut={this.onChipMouseOut}
                    >
                        {selectedValues.length === 0 ? (
                            <span className="placeholder">{placeholder}</span>
                        ) : (
                            <div className="chip" onMouseOut={this.onChipMouseOut}>
                                {selectedValues.map((val, idx) => {
                                    const item = data.find((d) => d[valueKey] === val);
                                    return (
                                        <div onMouseOver={this.onChipMouseOver} className="chipSelect" id={idx} key={idx}>
                                            <div className="chipVal">{item?.[labelKey]}</div>
                                            <button
                                                id="btnremove"
                                                type="button"
                                                className="cross"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.toggleValue(val);
                                                }}
                                                onMouseOver={this.onChipMouseOver}
                                            >
                                                <svg
                                                    width="8"
                                                    height="8"
                                                    viewBox="0 0 8 8"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M6.79465 0.229492L3.96598 3.05749L1.13798 0.229492L0.195312 1.17216L3.02331 4.00016L0.195312 6.82816L1.13798 7.77083L3.96598 4.94282L6.79465 7.77083L7.73731 6.82816L4.90931 4.00016L7.73731 1.17216L6.79465 0.229492Z"
                                                        fill="#6A6E73"
                                                    />
                                                </svg>
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                        <div
                            onMouseOver={this.onChipMouseOver}
                            className="coaSearch"
                            ref={(searchSection) => {
                                this.searchSection = searchSection;
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {opened && (
                                <div className="dropDownPanel" onClick={(e) => e.stopPropagation()}>
                                    {this.props.isSearch ? <div className="SearchInput">
                                        <input
                                            key={"text-Filter"}
                                            type="text"
                                            className="form-control"
                                            placeholder="Filter Search"
                                            value={inputValue}
                                            onChange={this.handleSearchChange}
                                        />
                                    </div> : <></>}
                                    <ul onWheel={() => hoverOutEllipsis()} >
                                        {filterData.length > 0 ? (
                                            filterData.map((item, idx) => (
                                                <li key={idx}>
                                                    <Form.Check
                                                        className="pRght"
                                                        type="checkbox"
                                                        label={
                                                            <EllipsisWithTooltip placement="bottom">
                                                                {this.props.showAccountTypeInLabel
                                                                    ? `${item[labelKey]} - ${item.accountType}`
                                                                    : item[labelKey]}
                                                            </EllipsisWithTooltip>
                                                        }
                                                        checked={selectedValues.includes(item[valueKey])}
                                                        onChange={() => this.toggleValue(item[valueKey])}
                                                    />
                                                </li>
                                            ))
                                        ) : (
                                            <li style={{ padding: "8px", textAlign: "center" }}>
                                                No data found
                                            </li>
                                        )}
                                    </ul>
                                            
                                    <>
                                        {this.props.isSelectAll && filterData.length > 0 && (
                                            <div ref={this.dropDownFooter} className="footer">
                                                {selectedValues.length !== data.length && (
                                                    <button
                                                        id="selectAll"
                                                        type="button"
                                                        className="btn wht-bg txt-green"
                                                        onClick={this.handleSelectAll}
                                                    >
                                                        Select All
                                                    </button>
                                                )}
                                                {selectedValues.length === data.length && (
                                                    <button
                                                        id="ClearAll"
                                                        type="button"
                                                        className="btn wht-bg txt-green"
                                                        onClick={this.handleClearAll}
                                                    >
                                                        Clear All
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    </>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </OutsideClickHandler>
        );
    }
}


MultiSelectCustomCard.defaultProps = {
    isSearch: true,
    isSelectAll: true
};